import { FC, useState } from 'react';
import styled from 'styled-components';
import { BasicButton } from 'src/components/widgets/buttons';
import { CustomErrorBoundary } from 'src/components/widgets/customErrorBoundary';
import { InlineSupportTicket } from 'src/components/widgets/supportTicketDropdown/supportTicketDropdown';
import Stack from 'src/components/widgets/stack/stack';
import { useAccountData } from 'src/shared/hooks/useAccountData';
import { T } from 'src/shared/helpers';
import { EmailSupportRequest, getSupportTicketMessage } from 'src/shared/aiSupport';

const Card = styled(Stack)<{ $embedded: boolean }>`
    padding: ${(props) => (props.$embedded ? '0' : '16px')};
    border: ${(props) => (props.$embedded ? 'none' : `1px solid ${props.theme.app.borderColor}`)};
    border-radius: ${(props) => (props.$embedded ? '0' : '8px')};
    overflow-wrap: anywhere;
    min-width: 0;
`;

export const AiSupportCard: FC<{ request: EmailSupportRequest; embedded?: boolean }> = ({ request, embedded = false }) => {
    const { userInfo } = useAccountData();
    const message = getSupportTicketMessage(request, userInfo.userID);
    const [retry, setRetry] = useState(0);
    return (
        <Card $embedded={embedded} $gap='12px' data-testid='ai-email-support-card'>
            <CustomErrorBoundary
                key={retry}
                render={() => (
                    <Stack $gap='8px'>
                        <div role='alert'>{T._('The support form is unavailable. Please try again.', 'Admin')}</div>
                        <BasicButton type='button' onClick={() => setRetry((value) => value + 1)}>
                            {T._('Retry', 'Admin')}
                        </BasicButton>
                    </Stack>
                )}
            >
                <InlineSupportTicket initialMessage={message} fetchKey={retry} />
            </CustomErrorBoundary>
        </Card>
    );
};
